import Icon, { IconType } from "./Icon";

export default function OpenIcon(props: IconType) {
  return (
    <Icon {...props}>
      <path d="m12.4 35.7-2.1-2.1L30.9 13H12v-3h24v24h-3V15.1Z" />
    </Icon>
  );
}
